document.addEventListener('alpine:init', () => {
    Alpine.data('shopTheLookItem', ({ product, index }) => ({
        formData: {},
        isIncluded: null,
        product: product,
        currentVariant: null,
        index: index,
        init() {
            this.$nextTick(() => {
                this.setCurrentVariant();
            });
            this.$watch('formData', (newValue) => {
                this.setCurrentVariant();
                this.updateParent()
            });

            this.$watch('isIncluded', (newValue) => {
                this.updateParent()
            });

        },
        updateParent() {
            this.$nextTick(() => {
                this.$dispatch('child-value-update', { id: this.index, childVariant: this.currentVariant, selected: this.isIncluded });
            });
        },
        setCurrentVariant() {
            let options = Object.values(this.formData);
            this.currentVariant = this.product?.variants.find((variant) => {
                return !variant.options
                    .map((option, index) => {
                        return options[index] === option;
                    })
                    .includes(false);
            });
        }
    }));
});